import script from "./UiProfileHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./UiProfileHeader.vue?vue&type=script&setup=true&lang=js"

import "./UiProfileHeader.vue?vue&type=style&index=0&id=2963cbb0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2963cbb0"]])

export default __exports__